module.exports = __webpack_public_path__ + "static/media/Accidental-Presidency.4b4c18b5.ttf";